import CryptoJS from 'crypto-js';
const aesKey = process.env.VUE_APP_AES_KEY; //密钥
/**
 * 通用js方法封装处理
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params =
    typeof search.params === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof propName === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

// 字符串格式化(%s )
export function sprintf(str) {
  let args = arguments,
      flag = true,
      i = 1;
  str = str.replace(/%s/g, function () {
    const arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
  if (!str || str == 'undefined' || str == 'null') {
    return '';
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (const p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  };

  const childrenListMap = {};
  const nodeIds = {};
  const tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d.id] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o.id] !== null) {
      o[config.childrenList] = childrenListMap[o.id];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 路由数据遍历
 *
 */
export function formatRoutes(routerArr) {
  let arr = [],
    obj = {};
  routerArr.forEach((tmp) => {
    obj = {
      id: tmp.id,
      pid: tmp.pid,
      name: tmp.name,
      url: tmp.component,
      path: '/' + tmp.pid + '/',
      perms: tmp.perms,
      child: tmp.childList.length
        ? tmp.childList.map((item) => {
            return {
              id: item.id,
              pid: item.pid,
              name: item.name,
              url: item.component,
              path: '/' + tmp.pid + '/' + item.pid + '/',
              perms: item.perms,
              extra: item.icon,
              child: item.childList.length
                ? item.childList.map((item1) => {
                    return {
                      id: item1.id,
                      pid: item1.pid,
                      name: item1.name,
                      url: item1.component,
                      path: '/' + tmp.pid + '/' + item.pid + '/' + item1.pid + '/',
                      perms: item1.perms,
                      extra: item1.icon,
                      child: item1.childList.length
                        ? item1.childList.map((item2) => {
                            return {
                              id: item2.id,
                              pid: item2.pid,
                              name: item2.name,
                              url: item2.component,
                              path: '/' + tmp.pid + '/' + item.pid + '/' + item1.pid + '/' + item2.pid + '/',
                              perms: item2.perms,
                              extra: item2.icon,
                            };
                          })
                        : [],
                    };
                  })
                : [],
            };
          })
        : [],
      extra: tmp.icon,
    };
    arr.push(obj);
  });
  return arr;
}

/**
 * AES加密处理（ECB模式）
 */
export function encryptECB(plaintText) {
  const options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  const key = CryptoJS.enc.Utf8.parse(aesKey); //秘钥
  const encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
  let encryptedBase64Str = encryptedData.toString()
  // let encryptedBase64Str = encryptedData.toString().replace(/\//g, '_');
  // encryptedBase64Str = encryptedBase64Str.replace(/\+/g, '-');
  return encryptedBase64Str;
}

/**
 * AES解密处理（ECB模式）
 */
export function decryptECB(encryptedBase64Str) {
  // const vals = encryptedBase64Str.replace(/-/g, '+').replace(/_/g, '/');
  const vals = encryptedBase64Str
  const options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  const key = CryptoJS.enc.Utf8.parse(aesKey); //秘钥
  const decryptedData = CryptoJS.AES.decrypt(vals, key, options);
  const decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
  return decryptedStr;
}
